var React = require('react');

function Wave (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"matrix(1,0,0,0.24187,0,23.7195)"},React.createElement("path",{"d":"M0,49.98C257.34,189.95 262.97,-46.88 500,49.98L500,150L0,150L0,49.98Z","style":{"fillRule":"nonzero"}})));
}

Wave.defaultProps = {"viewBox":"0 0 500 60","version":"1.1","xmlSpace":"preserve","style":{"fillRule":"evenodd","clipRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"2"}};

module.exports = Wave;

Wave.default = Wave;
